import { BinaryReader } from 'Loader/serialization/common/BinaryReader';
import TrianglesReader from 'Loader/serialization/common/TrianglesReader.js';
import type Triangle from '@data/geometry/Triangle';
import type FVector from '@data/geometry/FVector';
import GeomSerializable, { GeomHeaderSchema } from './GeomSerializable';
import { GeometryChunkId } from './GeometryChunkId';

type BaseSchema = {
    version: number;
};
type SchemaV5 = BaseSchema & {
    numberOfTrees: number;
    trees: { points: FVector[]; triangles: Triangle[] }[];
};
type PreviousSchema = SchemaV5;
export type LatestTreesSchema = SchemaV5;

class VegetationSerializer extends GeomSerializable<PreviousSchema, LatestTreesSchema> {
    protected readonly expectedChunkId = GeometryChunkId.Vegetation;
    private static readonly LATEST_VERSION = 5;

    protected migrateToLatest(anyPrevious: PreviousSchema): LatestTreesSchema {
        let migrated: PreviousSchema = anyPrevious;
        while (migrated.version < VegetationSerializer.LATEST_VERSION) {
            const migrate = this.getMigrationForVersion(migrated.version);
            if (!migrate) {
                throw new Error(`Missing Vegetation migration for version ${migrated.version}`);
            }
            migrated = migrate(migrated);
        }
        return migrated as LatestTreesSchema;
    }

    protected deserializeContent(header: GeomHeaderSchema, reader: BinaryReader): LatestTreesSchema {
        let parsed: PreviousSchema;
        if (header.version >= 5) {
            parsed = this.deserializeV5(header, reader);
        } else {
            throw new Error(`Unsupported Vegetation version: ${header.version}. Update your files`);
        }

        return this.migrateToLatest(parsed);
    }

    private getMigrationForVersion(_version: number): ((schema: PreviousSchema) => PreviousSchema) | undefined {
        return undefined;
    }

    private deserializeV5(header: GeomHeaderSchema, reader: BinaryReader): SchemaV5 {
        const V = reader.readUInt32();
        const trees: SchemaV5['trees'] = [];
        for (let i = 0; i < V; i++) {
            const points: FVector[] = [];
            const triangles: Triangle[] = [];
            TrianglesReader.read(reader, points, triangles, i);
            trees.push({ points, triangles });
        }

        return { version: header.version, numberOfTrees: V, trees };
    }
}

export default VegetationSerializer;
